import React, { useEffect, useMemo, useState } from "react";
import { CircularProgress, Grid, Tabs, Tab, Badge } from "@material-ui/core";
import useResources from "../../hooks/useResources";
import EmployeesDataGrid from "./EmployeesDataGrid";
import { isEmpty, isEqual } from "lodash";
import VesselsDataGrid from "./VesselsDataGrid";
import useResourceStatuses from "../../hooks/useResourceStatus";
import { getResourceAPI } from "../../redux/slices/resourceSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getUIProperty } from "../../redux/slices/uiSlice";
import { usePrevious } from "../../hooks/usePrevious";

const ClientPageTabs = () => {
  const dispatch = useDispatch();
  const { clientPageEmployees: employees, clientVessels } = useResources();

  const prevData = usePrevious({ employees, clientVessels });
  const clientId = useSelector((state) => getUIProperty(state, "clientId"));

  const [selectedIndex, setSelectedIndex] = useState(0);

  const { clientSearchStatus } = useResourceStatuses();

  const handleChange = (event, newValue) => {
    setSelectedIndex(newValue);
  };

  const content = useMemo(
    () => [
      <EmployeesDataGrid dataSource={employees} clientId={clientId} />,
      <VesselsDataGrid
        dataSource={
          !isEmpty(clientVessels)
            ? clientVessels.map((cv) => ({
                ...cv.vessel,
                vessel_systems: cv.vessel_systems,
              }))
            : []
        } clientId={clientId}
      />,
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isEqual(prevData, { employees, clientVessels })]
  );

  useEffect(() => {
    if (clientId) {
      dispatch(
        getResourceAPI({
          path: "client-search-details",
          query: { client_id: clientId },
        })
      );
    }
  }, [clientId, dispatch]);

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
        spacing={5}
        style={{ marginTop: "16px" }}
      >
        <Grid
          item
          container
          xs={12}
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          {clientSearchStatus === "done" && selectedIndex >= 0 && (
            <>
              <Tabs
                value={selectedIndex}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label={
                    <Badge
                      style={{ fontWeight: "bold" }}
                      badgeContent={employees.length}
                      color="primary"
                    >
                      Employees
                    </Badge>
                  }
                />
                <Tab
                  label={
                    <Badge
                      style={{ fontWeight: "bold" }}
                      badgeContent={clientVessels.length}
                      color="primary"
                    >
                      Vessels
                    </Badge>
                  }
                />
              </Tabs>
              {content[selectedIndex]}
            </>
          )}
          {clientSearchStatus === "pending" && <CircularProgress />}
          {clientSearchStatus === "done" && employees.length === 0 && (
            <p>No employees</p>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ClientPageTabs;
